export default (state = {
    fetchingProduct: false,
    fetched: false,
    product: false,

}, action) => {
    switch (action.type) {
        case 'FETCHING_FIND_PRODUCT' :
            return {
                ...state,
                fetchingProduct: true,
                fetched: false,
            };
        case 'FETCH_FIND_PRODUCT' :
            return {
                ...state,
                product: action.results,
                fetchingProduct: true,
                fetched: true
            };

        case 'RESET_FETCHED_PRODUCT' :
            return {
                ...state,
                product: false,
                fetchingProduct: false,
                fetched: false
            };
        case 'FETCHING_FIND_PRODUCT_FAILED' :
            return {
                ...state,
                fetchingProduct: 0,
                fetched: 0,
            };

        default:
            return state;
    }
};
